import { useMutation } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { Hook } from '@rossum/api-client/hooks';
import { api } from '../../../../../../lib/apiClient';
import { ExtendedHook } from '../helpers';

export const useUpdateDependenciesHook = () => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({
      selectedExtensionUrl,
      extensionsToAdd,
      extensionsToRemove,
      originalExtensions,
    }: {
      selectedExtensionUrl: ExtendedHook['url'] | undefined;
      extensionsToAdd: ExtendedHook[];
      extensionsToRemove: ExtendedHook[];
      originalExtensions: Hook[] | undefined;
    }) => {
      if (
        !(extensionsToAdd.length || extensionsToRemove.length) ||
        !selectedExtensionUrl
      ) {
        return Promise.reject(new Error('no_updates'));
      }
      const addRequests = extensionsToAdd.map(extension => {
        const originalExtension = originalExtensions?.find(
          e => e.url === extension.url
        );
        const _runAfter = originalExtension?.runAfter ?? [];
        const runAfter = [..._runAfter, selectedExtensionUrl];

        return extension?.id
          ? api.request(
              endpoints.hooks.patch(extension.id, {
                runAfter,
                type: extension.type,
              })
            )
          : null;
      });
      const removeRequests = extensionsToRemove.map(extension => {
        const originalExtension = originalExtensions?.find(
          e => e.url === extension.url
        );
        const _runAfter = originalExtension?.runAfter ?? [];
        const runAfter = _runAfter.filter(url => url !== selectedExtensionUrl);
        return extension?.id
          ? api.request(
              endpoints.hooks.patch(extension.id, {
                runAfter,
                type: extension.type,
              })
            )
          : null;
      });

      return Promise.all([...addRequests, ...removeRequests]);
    },
  });

  return { mutateAsync, isLoading };
};
